import { ID } from "@project/shared-types";
import { Copy } from "../../../components/Copy/Copy";
import { Text } from "../../../components/texts/text";
import Title from "../../../components/texts/title";
import { _sizeHeading, _sizeText } from "../../../core/core";
import "./ItemBasePage.css";
interface ItemBasePageFieldConfig {
  label: string;
  valueMapper?: (value: any) => any;
}

interface ItemBasePageProps<T> {
  id: ID;
  title: string;
  data: T;
  fieldConfig?: Partial<Record<keyof T, ItemBasePageFieldConfig>>;
  children?: React.ReactNode;
}

export const ItemBasePage = <T extends object>({
  id,
  title,
  data,
  fieldConfig,
  children,
}: ItemBasePageProps<T>) => {
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
          width: "100%",
        }}
      >
        <Title type={_sizeHeading.h3}>{title}</Title>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {Object.entries(data).map(([key, value]) => {
          const field = fieldConfig?.[key as keyof T];
          if (!field) return null;

          return (
            <div key={key} className="preview-object-row">
              <div style={{ minWidth: "150px" }}>
                <Text size={_sizeText.mbold}>{field.label}:</Text>
              </div>
              <div>
                <Copy value={value}>
                  <Text>
                    {field.valueMapper
                      ? field.valueMapper(value)
                      : typeof value === "object"
                      ? JSON.stringify(value, null, 2)
                      : String(value)}
                  </Text>
                </Copy>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
